import React from 'react';
import { Trophy, Users, Award, Briefcase, Globe, TrendingUp, Zap } from 'lucide-react';
import { Winner, Program, Stat } from './types';

export const WINNERS: Winner[] = [
  {
    name: 'Bassey',
    title: '1st Place',
    prize: 'NGN 1,000,000',
    img: 'https://i.ibb.co/Hp4q8PyB/1.jpg',
    year: '2024',
    story:
      'Miss Bassey was crowned 1st Place for her exceptional business acumen and her visionary approach to community empowerment.',
    gallery: [
      'https://i.ibb.co/Hp4q8PyB/1.jpg',
      'https://i.ibb.co/zTpNF0DV/2.jpg',
      'https://i.ibb.co/TBFMQR4f/3.jpg',
    ],
  },
  {
    name: 'Fatima',
    title: '2nd Place',
    prize: 'NGN 700,000',
    img: 'https://i.ibb.co/xS3C0XRF/1.jpg',
    year: '2024',
    story: 'Miss Fatima secured 2nd Place with her innovative startup concept and dedication to social impact.',
    gallery: [
      'https://i.ibb.co/xS3C0XRF/1.jpg',
      'https://i.ibb.co/WWFKjfDs/2.jpg',
      'https://i.ibb.co/VhS76cr/3.jpg',
    ],
  },
  {
    name: 'Gloria',
    title: '3rd Place',
    prize: 'NGN 500,000',
    img: 'https://i.ibb.co/MHFhwV8/Delight-3rd-Place-Miss-Gloria-500-K.jpg',
    year: '2024',
    story: "Miss Gloria's creative vision and entrepreneurial spirit earned her the 3rd Place position.",
    gallery: [
      'https://i.ibb.co/MHFhwV8/Delight-3rd-Place-Miss-Gloria-500-K.jpg',
      'https://i.ibb.co/7drkXzKX/Delight-3rd-Place-Miss-Gloria.jpg',
    ],
  },
];

const genericWinnerStory =
  'We understand that behind every business is a dream, and behind every dream is a person striving for a better future. Our platform is more than just a resource hub and it is a support system designed to ensure that effort, creativity, and determination are recognized and rewarded.';

export const UNNAMED_WINNERS: Winner[] = [
  {
    name: '',
    title: 'WINNER',
    prize: '',
    img: 'https://i.ibb.co/gbsbrrN6/Whats-App-Image-2026-04-08-at-10-16-11-AM.jpg',
    year: '2024',
    hideDetails: true,
    gallery: ['https://i.ibb.co/gbsbrrN6/Whats-App-Image-2026-04-08-at-10-16-11-AM.jpg'],
  },
  {
    name: '',
    title: 'WINNER',
    prize: '',
    img: 'https://i.ibb.co/k2qpzYQ8/Whats-App-Image-2026-04-08-at-10-16-12-AM.jpg',
    year: '2024',
    hideDetails: true,
    gallery: ['https://i.ibb.co/k2qpzYQ8/Whats-App-Image-2026-04-08-at-10-16-12-AM.jpg'],
  },
  {
    name: '',
    title: 'WINNER',
    prize: '',
    img: 'https://i.ibb.co/jkX5BgHZ/Whats-App-Image-2026-04-08-at-10-16-18-AM.jpg',
    year: '2024',
    hideDetails: true,
    gallery: ['https://i.ibb.co/jkX5BgHZ/Whats-App-Image-2026-04-08-at-10-16-18-AM.jpg'],
  },
  {
    name: '',
    title: 'WINNER',
    prize: '',
    img: 'https://i.ibb.co/6cJt9kcZ/Whats-App-Image-2026-04-08-at-10-16-21-AM-1.jpg',
    year: '2024',
    hideDetails: true,
    gallery: ['https://i.ibb.co/6cJt9kcZ/Whats-App-Image-2026-04-08-at-10-16-21-AM-1.jpg'],
  },
  {
    name: '',
    title: 'WINNER',
    prize: '',
    img: 'https://i.ibb.co/0PbJL21/Whats-App-Image-2026-04-08-at-10-16-23-AM-2.jpg',
    year: '2024',
    hideDetails: true,
    gallery: ['https://i.ibb.co/0PbJL21/Whats-App-Image-2026-04-08-at-10-16-23-AM-2.jpg'],
  },
  {
    name: '',
    title: 'WINNER',
    prize: '',
    img: 'https://i.ibb.co/wNdgxfCj/Whats-App-Image-2026-04-08-at-10-16-23-AM-4.jpg',
    year: '2024',
    hideDetails: true,
    gallery: ['https://i.ibb.co/wNdgxfCj/Whats-App-Image-2026-04-08-at-10-16-23-AM-4.jpg'],
  },
  {
    name: '',
    title: 'WINNER',
    prize: '',
    img: 'https://i.ibb.co/5xJjg4wK/Whats-App-Image-2026-04-08-at-10-16-24-AM-1.jpg',
    year: '2024',
    hideDetails: true,
    gallery: ['https://i.ibb.co/5xJjg4wK/Whats-App-Image-2026-04-08-at-10-16-24-AM-1.jpg'],
  },
  {
    name: '',
    title: 'WINNER',
    prize: '',
    img: 'https://i.ibb.co/SwHmkv1Q/Whats-App-Image-2026-04-08-at-10-16-24-AM-4.jpg',
    year: '2024',
    hideDetails: true,
    gallery: ['https://i.ibb.co/SwHmkv1Q/Whats-App-Image-2026-04-08-at-10-16-24-AM-4.jpg'],
  },
  {
    name: '',
    title: 'WINNER',
    prize: '',
    img: 'https://i.ibb.co/C32WVv79/Whats-App-Image-2026-04-08-at-10-16-24-AM.jpg',
    year: '2024',
    hideDetails: true,
    gallery: ['https://i.ibb.co/C32WVv79/Whats-App-Image-2026-04-08-at-10-16-24-AM.jpg'],
  },
  {
    name: '',
    title: 'WINNER',
    prize: '',
    img: 'https://i.ibb.co/kgmwFx5r/Whats-App-Image-2026-04-08-at-10-16-25-AM-1.jpg',
    year: '2024',
    hideDetails: true,
    gallery: ['https://i.ibb.co/kgmwFx5r/Whats-App-Image-2026-04-08-at-10-16-25-AM-1.jpg'],
  },
  {
    name: '',
    title: 'WINNER',
    prize: '',
    img: 'https://i.ibb.co/B5dRXxNJ/Whats-App-Image-2026-04-08-at-10-16-26-AM-1.jpg',
    year: '2024',
    hideDetails: true,
    gallery: ['https://i.ibb.co/B5dRXxNJ/Whats-App-Image-2026-04-08-at-10-16-26-AM-1.jpg'],
  },
  {
    name: '',
    title: 'WINNER',
    prize: '',
    img: 'https://i.ibb.co/S4RSQyGT/Whats-App-Image-2026-04-08-at-10-16-26-AM-2.jpg',
    year: '2024',
    hideDetails: true,
    gallery: ['https://i.ibb.co/S4RSQyGT/Whats-App-Image-2026-04-08-at-10-16-26-AM-2.jpg'],
  },
  {
    name: '',
    title: 'WINNER',
    prize: '',
    img: 'https://i.ibb.co/Cp5QbqfJ/Whats-App-Image-2026-04-08-at-10-16-26-AM-4.jpg',
    year: '2024',
    hideDetails: true,
    gallery: ['https://i.ibb.co/Cp5QbqfJ/Whats-App-Image-2026-04-08-at-10-16-26-AM-4.jpg'],
  },
];

export const PROGRAMS: Program[] = [
  {
    id: 1,
    title: 'Startup Capital',
    desc: 'We give out startup capital to our winners to help them establish and upgrade their businesses respectively.',
    longDesc:
      'We provide the financial support needed to take meaningful steps toward growth and stability, ensuring that effort, creativity, and determination are recognized and rewarded.',
    icon: React.createElement(Briefcase, { className: 'w-6 h-6' }),
    color: 'bg-amber-50 text-amber-700',
  },
  {
    id: 2,
    title: 'Empowerment Initiatives',
    desc: 'Providing real opportunities, practical support, valuable exposure, and the right resources.',
    longDesc:
      'Through our empowerment programs, contests, and initiatives, we provide participants with opportunities to gain financial support, business exposure, mentorship, and tools that can help them scale.',
    icon: React.createElement(Award, { className: 'w-6 h-6' }),
    color: 'bg-amber-50 text-amber-700',
  },
  {
    id: 3,
    title: 'Mentorship & Growth',
    desc: 'Building confidence, encouraging innovation, and promoting sustainable growth.',
    longDesc:
      'Our goal is not only to celebrate winners, but to create lasting impact by building confidence, encouraging innovation, and promoting sustainable growth through strategic support systems.',
    icon: React.createElement(Users, { className: 'w-6 h-6' }),
    color: 'bg-stone-100 text-stone-700',
  },
];

export const STATS: Stat[] = [
  { label: 'Grants Awarded', value: 'NGN 25M+', icon: React.createElement(Trophy, { className: 'w-5 h-5' }) },
  { label: 'Lives Impacted', value: '5,000+', icon: React.createElement(Globe, { className: 'w-5 h-5' }) },
  { label: 'Businesses Scaled', value: '500+', icon: React.createElement(TrendingUp, { className: 'w-5 h-5' }) },
  { label: 'Empowerment Events', value: '15+', icon: React.createElement(Zap, { className: 'w-5 h-5' }) },
];
